module.exports = __webpack_public_path__ + "static/media/dark-theme-speed.645824f4.svg";